<template>
    <div class="row mt-5" v-if="showloader=='no'">
        <div class="col-md-12">
            <div class="col-md-3 offset-1  text-dark">
                <label class="text-light">
                    Select Year and Month
                </label>
                <vue-monthly-picker
                    v-model="selectedMonth"
                    placeHolder="Select Month"
                    @input="getbranchreports(false)"

                >

                </vue-monthly-picker>

            </div>
        </div>


        <h1 class="col-md-12 text-center text-light mb-4">
            <div class="btn-group p-1" role="group" style="background: rgba(255,255,255,0.1); border-radius: 50px;">
                <button
                    type="button"
                    class="btn px-5 py-2 btn-tab"
                    :class="this_month ? 'btn-info active-tab' : 'btn-outline-light border-0'"
                    @click="this_month = true"
                >
                    <i class="fas fa-calendar-alt mr-2"></i> This Month
                </button>
                <button
                    type="button"
                    class="btn px-5 py-2 btn-tab"
                    :class="!this_month ? 'btn-info active-tab' : 'btn-outline-light border-0'"
                    @click="this_month = false"
                >
                    <i class="fas fa-clock mr-2"></i> Today
                </button>
            </div>
            <div class="mt-2" style="font-size: 1.5rem; font-weight: 300; letter-spacing: 2px; text-transform: uppercase;">
                League Table
            </div>
        </h1>
        <!--                <div class="col-md-4 text-right  offset-7" >-->

        <!--                    <b-link class="mx-1" :to="{ path: '/branch-league' }">-->
        <!--                        <button class="btn btn-warning btn-sm " >Branch League</button>-->
        <!--                    </b-link>-->

        <!--                </div>-->
        <h1 class="col-md-6 offset-3 "> <hr class="hr0" style="margin-top: 0px !important;"></h1>
        <!--                <div class="col-md-5 offset-1">-->
        <!--                    <h1 class="text-center text-light">This Week</h1>-->
        <!--                    <table class="table text-light table-bordered" >-->
        <!--                        <thead >-->

        <!--                        <th >Position</th>-->
        <!--                        <th >Sales Person</th>-->
        <!--                        <th >This Week</th>-->

        <!--                        </thead>-->
        <!--                        <tbody>-->
        <!--                        <tr v-for="(sale_person, index) in sorted_cashiers.sortedCashiersthisweek" :key="sale_person.id" :class="[sale_person.twbgclass, { 'red-background': index >= sorted_cashiers.sortedCashiersthisweek.length - 3 }]">-->
        <!--                            <td v-if="sale_person.thisweek_no==1"> First </td>-->
        <!--                            <td v-else-if="sale_person.thisweek_no==2"> Second </td>-->
        <!--                            <td v-else-if="sale_person.thisweek_no==3"> Third </td>-->
        <!--                            <td v-else=""> {{sale_person.thisweek_no}}<sup>th</sup> </td>-->
        <!--                            <td> {{sale_person.fullName}} </td>-->
        <!--                            <td>-->
        <!--                              <span v-if="((Number(sale_person.this_week) / Number(sale_person.this_week_comapny_sale)) * 100).toFixed(2)=='NaN'"> 0 </span>-->
        <!--                                <span v-else="">-->
        <!--                                       {{((Number(sale_person.this_week) / Number(sale_person.this_week_comapny_sale)) * 100).toFixed(2)}}-->
        <!--                                </span>-->
        <!--                                %-->

        <!--                            </td>-->
        <!--                        </tr>-->

        <!--                        </tbody>-->
        <!--                    </table>-->

        <!--                    <h1 class="col-md-12 "> <hr class="hr0"></h1>-->
        <!--                </div>-->
        <div class="col-md-6 offset-3 " v-if="this_month">
            <h1 class="text-center text-light">This Month</h1>
            <table class="table text-light table-bordered">
                <thead >

                <th >Position</th>
                <th >Sales Person</th>
                <th >This Month</th>
                <th >Reward</th>


                </thead>
                <tbody>
                <tr v-for="(sale_person_tm, index) in sorted_cashiers.sortedCashiersthismonth" :key="sale_person_tm.id" class="text-dark"
                    :class="[
                        sale_person_tm.bgclass,
                        { 'red-background': index > 14 },
                        index >= sorted_cashiers.sortedCashiersthismonth.length - 3 ? 'bg-black-now text-white-now' : 'text-dark'
                    ]">
                    <td v-if="sale_person_tm.thismonth_no==1"> First </td>
                    <td v-else-if="sale_person_tm.thismonth_no==2"> Second </td>
                    <td v-else-if="sale_person_tm.thismonth_no==3"> Third </td>
                    <td v-else=""> {{sale_person_tm.thismonth_no}}<sup>th</sup> </td>
                    <td> {{sale_person_tm.fullName}} </td>
                    <td>
                                <span v-if="((sale_person_tm.this_month / sale_person_tm.this_month_comapny_sale) * 100).toFixed(2)=='NaN'">
                                    0
                                </span>
                        <span v-else="">
                                     {{((sale_person_tm.this_month / sale_person_tm.this_month_comapny_sale) * 100).toFixed(2)}}
                                </span>
                        % ({{(sale_person_tm.this_month).toFixed(2)}})

                    </td>

                    <td>
                                <span v-if="((sale_person_tm.this_month / sale_person_tm.this_month_comapny_sale) * 100).toFixed(2)=='NaN'">
                                    0
                                </span>
                        <span v-else="">

                            <span v-if="((sale_person_tm.this_month / sale_person_tm.this_month_comapny_sale) * 100 * commission_times(sale_person_tm.thismonth_no)).toFixed(2)==0" >
                           <span v-if="index >= sorted_cashiers.sortedCashiersthismonth.length - 3" class="fs-2">
                              💩
                           </span>
                          <span v-else>
                                <i class="bi bi-hand-thumbs-down-fill  fs-2" ></i>
                           </span>
                            </span>
                            <span v-else>
                                 £  {{((sale_person_tm.this_month / sale_person_tm.this_month_comapny_sale) * 100 * commission_times(sale_person_tm.thismonth_no)).toFixed(2)}}
                            </span>


                                </span>

                    </td>
                </tr>

                </tbody>
            </table>

            <h1 class="col-md-12 "> <hr class="hr0"></h1>
        </div>

        <div class="col-md-6 offset-3 " v-else>
            <h1 class="text-center text-light">Today</h1>
            <table class="table text-light table-bordered">
                <thead >

                <th >Position</th>
                <th >Sales Person</th>
                <th >Today</th>



                </thead>
                <tbody>
                <tr v-for="(sale_person_today, index) in sorted_cashiers.sortedCashierstoday" :key="sale_person_today.id" class="text-dark" :class="[sale_person_today.todaybgclass, { 'red-background': index >14 }]">
                    <td v-if="sale_person_today.today_no==1"> First </td>
                    <td v-else-if="sale_person_today.today_no==2"> Second </td>
                    <td v-else-if="sale_person_today.today_no==3"> Third </td>
                    <td v-else=""> {{sale_person_today.today_no}}<sup>th</sup> </td>
                    <td> {{sale_person_today.fullName}} </td>
<!--                    <td v-if="sale_person_today.today_no==1">-->
                    <td v-if="false">

                          <span v-if="sale_person_today.today=='NaN'">
                                    0
                                </span>
                        <span v-else="">
                                      £ {{(sale_person_today.today).toFixed(2)}}
                                </span>
                    </td>
                    <td v-else>
                                <span v-if="((sale_person_today.today / sale_person_today.today_comapny_sale) * 100).toFixed(2)=='NaN'">
                                    0
                                </span>
                        <span v-else="">
                                     {{((sale_person_today.today / sale_person_today.today_comapny_sale) * 100).toFixed(2)}}
                                </span>
                        %
                    </td>


                </tr>

                </tbody>
            </table>

            <h1 class="col-md-12 "> <hr class="hr0"></h1>
        </div>

        <!--                <h1 class=" col-md-12 text-center text-light">League Table</h1>-->
        <!--                <table class="table text-light table-bordered">-->
        <!--                    <thead >-->

        <!--                    <th >Sales Person</th>-->
        <!--                    <th >This Week</th>-->
        <!--                    <th >Last Week</th>-->
        <!--                    <th >This Month</th>-->
        <!--                    <th >Last Month</th>-->

        <!--                    </thead>-->
        <!--                    <tbody>-->
        <!--                    <tr v-for="sale_person in this.branch_report.league_table" :key="sale_person.id">-->
        <!--                        <td> {{sale_person.fullName}} </td>-->
        <!--                        <td>-->
        <!--                            <sup v-if="(sorted_cashiers.sortedCashiersthisweek.find((sc)=>sc.id==sale_person.id)).thisweek_no==1">-->
        <!--                                <div class="notify_position">-->
        <!--                                    {{(sorted_cashiers.sortedCashiersthisweek.find((sc)=>sc.id==sale_person.id)).thisweek_no }}-->
        <!--                                </div>-->
        <!--                            </sup>-->
        <!--                            £ {{formatNumberWithCommas(Number(sale_person.this_week).toFixed(2))}}-->
        <!--                        </td>-->
        <!--                        <td>-->
        <!--                            <sup v-if="(sorted_cashiers.sortedCashierslastweek.find((sc)=>sc.id==sale_person.id)).lastweek_no==1">-->
        <!--                                <div class="notify_position">-->
        <!--                                    {{(sorted_cashiers.sortedCashierslastweek.find((sc)=>sc.id==sale_person.id)).lastweek_no }}-->
        <!--                                </div>-->
        <!--                            </sup>-->
        <!--                            £ {{formatNumberWithCommas(Number(sale_person.last_week).toFixed(2))}} </td>-->
        <!--                        <td>-->
        <!--                            <sup v-if="(sorted_cashiers.sortedCashiersthismonth.find((sc)=>sc.id==sale_person.id)).thismonth_no==1">-->
        <!--                                <div class="notify_position">-->
        <!--                                    {{(sorted_cashiers.sortedCashiersthismonth.find((sc)=>sc.id==sale_person.id)).thismonth_no }}-->
        <!--                                </div>-->
        <!--                            </sup>-->
        <!--                            £ {{formatNumberWithCommas(Number(sale_person.this_month).toFixed(2))}} </td>-->
        <!--                        <td>-->
        <!--                            <sup v-if="(sorted_cashiers.sortedCashierslastmonth.find((sc)=>sc.id==sale_person.id)).lastmonth_no==1">-->
        <!--                                <div class="notify_position">-->
        <!--                                    {{(sorted_cashiers.sortedCashierslastmonth.find((sc)=>sc.id==sale_person.id)).lastmonth_no }}-->
        <!--                                </div>-->
        <!--                            </sup>-->
        <!--                            £ {{formatNumberWithCommas(Number(sale_person.last_month).toFixed(2))}} </td>-->


        <!--                    </tr>-->
        <!--                    </tbody>-->
        <!--                </table>-->
    </div>
</template>




<script>
import apiService from "@/service/apiService";
//import { mapActions } from "vuex";
import {mapActions, mapGetters} from 'vuex';
import { mapState } from 'vuex';





import VueMonthlyPicker from 'vue-monthly-picker'
import moment from "moment";
import Loader from "@/components/loader";
import {cloneDeep} from "lodash";
import vSelect from "vue-select";

import URL from "@/constants/baseurl";


export default {
    name: "salesmenleague",

    components:{ Loader,'v-select': vSelect ,VueMonthlyPicker},
    computed: {
        ...mapGetters(['AuthenticatedUser']),

        ...mapState('invoice', ['branches']),
        ...mapState('passwordprotection', ['credentials']),



        authenticatedUser() {
            let user = localStorage.getItem('user');
            user = JSON.parse(user)
            return user
        },
        sorted_cashiers(){
            //  const N = 3;
            let sortedCashiers={}
            let lgtable= cloneDeep(this.branch_report.league_table)
            const sortedCashiersthisweek = lgtable.slice().sort((a, b) => b.this_week - a.this_week);
            sortedCashiersthisweek.forEach((item, index) => {
                item.thisweek_no = index + 1;
                if(item.thisweek_no==1){
                    item.twbgclass='first'
                }
                else if (item.thisweek_no==2){
                    item.twbgclass='second'
                }
                else if (item.thisweek_no==3){
                    item.twbgclass='third'
                }
                else {
                    item.twbgclass='normalbg'
                }
            });
            const sortedCashierslastweek = lgtable.slice().sort((a, b) => b.last_week - a.last_week);
            sortedCashierslastweek.forEach((item, index) => {
                item.lastweek_no = index + 1;
            });
            const sortedCashiersthismonth = lgtable.slice().sort((a, b) => b.this_month - a.this_month);
            sortedCashiersthismonth.forEach((item, index) => {
                item.thismonth_no = index + 1;
                if(item.thismonth_no>=1 && item.thismonth_no<=3){
                    item.bgclass='gold_cls'
                }
                else if (item.thismonth_no>=4 && item.thismonth_no<=7){
                    item.bgclass='silver_cls'
                }
                else if (item.thismonth_no>=8&& item.thismonth_no<=11){
                    item.bgclass='bronze_cls'
                }
                else if (item.thismonth_no>=12&& item.thismonth_no<=15){
                    item.bgclass='orange_cls'
                }
                else {
                    item.bgclass='normalbg'
                }
            });
            const sortedCashierslastmonth = lgtable.slice().sort((a, b) => b.last_month - a.last_month);
            sortedCashierslastmonth.forEach((item, index) => {
                item.lastmonth_no = index + 1;
            });

            const sortedCashierstoday = lgtable.slice().sort((a, b) => b.today - a.today);
            sortedCashierstoday.forEach((item, index) => {
                item.today_no = index + 1;
                if(item.today_no>=1 && item.today_no<=3){
                    item.todaybgclass='gold_cls'
                }
                else if (item.today_no>=4 && item.today_no<=7){
                    item.todaybgclass='silver_cls'
                }
                else if (item.today_no>=8&& item.today_no<=11){
                    item.todaybgclass='bronze_cls'
                }
                else if (item.today_no>=12&& item.today_no<=15){
                    item.todaybgclass='orange_cls'
                }
                else {
                    item.todaybgclass='normalbg'
                }
            });
            //   const topNCashiers = sortedCashier.slice(0, N);
            sortedCashiers.sortedCashiersthisweek=sortedCashiersthisweek;
            sortedCashiers.sortedCashierslastweek=sortedCashierslastweek;
            sortedCashiers.sortedCashiersthismonth=sortedCashiersthismonth;
            sortedCashiers.sortedCashierstoday=sortedCashierstoday;
            sortedCashiers.sortedCashierslastmonth=sortedCashierslastmonth;
            return sortedCashiers;
        }

    },
    data() {
        return {
            this_month:true,
            branch_target:null,
            selectedMonth:"",
            roles: [],
            user: {},
            branch_report:{},
            showloader:'',
            branch_id:"",



        };
    },
    async created() {
        //  await this.getUsers();
        //  await this.getRoles();
        // await this.getbranches()
        // await this.getcashiers()

        const promises = [

            this.reloadcb(),

            this.get_branch_target()

        ];
        await Promise.all(promises);



    },
    async mounted() {
        await this.getbranchreports()




    },
    methods: {
        ...mapActions(['login', 'processLogoutManual']),
        ...mapActions('invoice', ['getbranches']),
        async reloadcb(){
            if(this.branches.length==0){
                //   alert(this.branches.length)
                await this.getbranches()

            }
            // if(this.cashiers.length==0){
            //     await this.getcashiers()
            // }
        },

        commission_times(position){
            if(position==1){
                return 15
            }
            else if (position==2){
                return 10
            }
            else if (position==3){
                return 7.5
            }
            else if (position >= 4 && position <= 7) {
                return 5;
            }
            else if (position >= 8 && position <= 11) {
                return 2.5;
            }
            else if (position >= 12 && position <= 15) {
                return 1;
            }
            else if (position >15) {
                return 0;
            }
        },


        async getbranchreports(curdate=true){
            this.showloader='yes'
            let branch_id=this.authenticatedUser.branch.id
            if(this.branch_id){
                branch_id=this.branch_id
            }
            let formattedDate=moment().format('YYYY-MM-DD HH:mm:ss');
            if(this.selectedMonth){
                formattedDate = moment(this.selectedMonth).format('YYYY-MM-DD HH:mm:ss');
            }

            if(curdate==true){

                formattedDate= moment().format('YYYY-MM-DD HH:mm:ss');


            }
            // console.log(this.selectedMonth,'ok')
            const {data} = await apiService.get(`/branch-reports`,{
                params: {
                    le_date: formattedDate,
                        id: branch_id
                }
            });
            //  console.log('branch_reports', data)
            this.showloader='no'
            this.branch_report=data
            console.log('branch_reports', this.branch_report.league_table)

        },
        formatNumberWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatDate(date){
            let date1 = new Date(date)
            let date2 =  moment(date1).format('D MMMM, h:mm A');

            return date2;
        },




        // updateRangeOptions() {
        //     // Parse the selected date values
        //     const fromDate = new Date(this.dateFrom)
        //     const toDate = new Date(this.dateTo)
        //     const today = new Date()
        //
        //   let  getrangeOptions={
        //       tday:false,
        //       yday:false,
        //       tweek:false,
        //       lweek:false,
        //       tmonth:false,
        //       lmonth:false,
        //     }
        //
        //
        //     // Calculate date differences
        //     const daysDifference = (toDate - fromDate) / (1000 * 60 * 60 * 24);
        //
        //     // Update range options based on date selections
        //    // console.log(daysDifference,today.getDay())
        //     if( toDate.getDay() == today.getDay()) {
        //         getrangeOptions.tday=true;
        //     }
        //     if(daysDifference > 0 ) {
        //         getrangeOptions.yday=true
        //     }
        //
        //
        //     if(daysDifference >1 && daysDifference <= today.getDay()) {
        //         getrangeOptions.tweek=true
        //
        //     }
        //    if(daysDifference > today.getDay()) {
        //        getrangeOptions.lweek=true
        //        getrangeOptions.tweek=true
        //
        //     }
        //    if( daysDifference+today.getDay() > 15 &&
        //         fromDate.getMonth() === today.getMonth() &&
        //         toDate.getMonth() === today.getMonth()) {
        //        getrangeOptions.tmonth=true
        //     }
        //   if(
        //       fromDate.getMonth() === today.getMonth() - 1) {
        //       getrangeOptions.lmonth=true
        //       getrangeOptions.tmonth=true
        //     }
        //
        //
        //     this.rangeOptions=[]
        //     for (let x in getrangeOptions) {
        //
        //         if(getrangeOptions[x]){
        //             this.rangeOptions.push(x)
        //         }
        //     }
        //   //  console.log(this.rangeOptions)
        //    this.rangeOptions =  this.rangeOptions.map(ro=>{
        //         if (ro=='tday') return 'Today'
        //         else if(ro=='yday') return 'Yesterday'
        //         else if(ro=='tweek') return 'This Week'
        //         else if(ro=='lweek') return 'Last Week'
        //         else if(ro=='tmonth') return 'This Month'
        //         else if(ro=='lmonth') return 'Last Month'
        //     })
        // //    console.log(this.rangeOptions)
        //
        // },
        // async getbranches(){
        //     const {data} = await apiService.get(`/branches`);
        //     console.log('branches', data)
        //     this.branches=data
        // },


    },
}
</script>

<style scoped>
@import '../../../assets/styles/pos.css';
.hide {
    visibility: hidden !important;
}
.hr0{
    margin-top: 15px;
    margin-bottom: 0px;

    border: 0;
    border-top: 3px solid #ffffff;
    max-width: 100%;

}

.notify_position {

    margin-right: -6px;
    width: 20px; /* Adjust the size as needed */
    height: 20px; /* Adjust the size as needed */
    background-color: green;
    color: white;
    border-radius: 50%; /* Makes it a circle */
    text-align: center;
    line-height: 20px; /* Vertically centers the text */
    font-size: 11px; /* Adjust the font size as needed */
    display: inline-block;
    font-weight: bolder;
}

.gold_cls {
    background-color: gold;
}
.silver_cls {
    background-color: silver;
}
.bronze_cls {
    background-color: #CD7F32;
}
.orange_cls {
    background-color: orange;
}

.red-background{
    background-color: red;
}


/* Styling for the Tab Buttons */
.btn-tab {
    border-radius: 50px !important; /* Makes buttons rounded */
    font-weight: 600;
    transition: all 0.3s ease;
    min-width: 160px;
}

.active-tab {
    box-shadow: 0 4px 15px rgba(23, 162, 184, 0.5); /* Glow effect for active tab */
    transform: scale(1.05);
}

/* Optional: Animation for switching tables */
.table {
    animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Ensure the container of the buttons looks like a track */
.btn-group {
    border: 1px solid rgba(255, 255, 255, 0.2);
}



.bg-black-now {
    background-color: #000000 !important;
}

.bg-black-now td,
.bg-black-now {
    color: #ffffff !important;
}


.fs-2 {
    font-size: 2rem;
}


</style>

